import React from 'react';
import ForgotPasswordForm from "./ForgotPasswordForm";
import "./Login.css";
import { Link } from 'react-router-dom';
import learningCube from '../../assets/images/learning-strategy/learning_cube.svg';

const LOGO_SRC = 'https://ia.intelladapt.ai/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Flogo.bb151063.png&w=256&q=75';

function ForgotPassword() {
    return (
        <div className="login-page-container">
            <header className="landing-header">
                <img src={LOGO_SRC} alt="Learning Strategy Logo" className="landing-logo-img" />
                <nav className="landing-nav">
                    <Link to="/">About</Link>
                    <Link to="/contact">Contact</Link>
                    <Link to="/login" className="landing-nav-login-btn">Login</Link>
                </nav>
            </header>
            <div className="login">
                <div className="login-content">
                    <div className="learning-cube-image">
                        <img 
                            src={learningCube} 
                            alt="Learning Cube" 
                            className="cube-img"
                        />
                    </div>
                    <div className="quiz__main">
                        <h2 className="forgot-password-title">Reset Your Password</h2>
                        <p className="forgot-password-subtitle">
                            Enter your email address and we'll send you instructions to reset your password.
                        </p>
                        <ForgotPasswordForm />
                        <div className="back-to-login">
                            <Link to="/login" className="back-link">
                                ← Back to Login
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword; 